// View Transitions für Turbo-Navigation (z. B. Quiz-Fragen).
// https://developer.mozilla.org/en-US/docs/Web/CSS/view-transition-name

function hasQuizQuestionHeading(doc) {
  return !!doc.querySelector?.("[data-view-transition='quiz-question-heading']");
}

document.addEventListener("turbo:before-render", (event) => {
  if (typeof document.startViewTransition !== "function") return;

  const { newBody, resume } = event.detail;
  if (!resume) return;

  const fromQuiz = hasQuizQuestionHeading(document);
  const toQuiz = hasQuizQuestionHeading(newBody);

  // Nur zwischen Frageseiten (beide Seiten haben den markierten Block)
  if (!fromQuiz || !toQuiz) return;

  event.preventDefault();
  document.startViewTransition(() => {
    resume();
  });
});
